import CNPJ from "./CNPJ";

export default class Utils {
  public static openExternalLink(url: string) {
    window.open(url, '_blank', 'noreferrer');
  }

  public static toDateAndTime(date: Date | string) {
    date = date instanceof Date ? date : new Date(date);
    return `${date.toLocaleDateString([], {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
    })} - ${date.toLocaleTimeString([], {
      timeStyle: "short",
      hour12: false
    })}`;
  }
  public static toDate(date: Date | string) {
    date = date instanceof Date ? date : new Date(date);
    return `${date.toLocaleDateString([], {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
    })}`;
  }
  public static toInputDateString(date: Date | string) {
    date = date instanceof Date ? date : new Date(date);
    return `${date
      .toLocaleDateString("pt-BR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-")}T${date.toLocaleTimeString([], {
        timeStyle: "short",
        hour12: false
      })}`;
  }

  public static toInputDateStringNoTime(date: Date | string) {
    date = date instanceof Date ? date : new Date(date);
    return `${date
      .toLocaleDateString("pt-BR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        timeZone: "UTC",
      })
      .split("/")
      .reverse()
      .join("-")}`;
  }

  public static dateValidation(date: string | Date, type: "<" | ">" | "=", limitDate: string | Date) {
    date = date instanceof Date ? date : new Date(date);
    limitDate = limitDate instanceof Date ? limitDate : new Date(limitDate);
    if (type === "=") {
      if (date.toLocaleDateString() === limitDate.toLocaleDateString()) {
        if (date.getHours() === limitDate.getHours() && date.getMinutes() === limitDate.getMinutes()) {
          return true;
        }
      } else {
        return false;
      }
    }
    if (type === ">") {
      if (date > limitDate) {
        return true;
      } else if ((date === limitDate && date.getHours() > limitDate.getHours())) {
        return true
      } else if ((date === limitDate && date.getHours() === limitDate.getHours() && date.getMinutes() > limitDate.getMinutes())) {
        return true
      } else {
        return false;
      }
    }
    if (type === "<") {
      if (date < limitDate) {
        return true;
      } else if ((date === limitDate && date.getHours() < limitDate.getHours())) {
        return true
      } else if ((date === limitDate && date.getHours() === limitDate.getHours() && date.getMinutes() < limitDate.getMinutes())) {
        return true
      } else {
        return false;
      }
    }
  }
  public static discountsDateValidation(date: string | Date, previousDates: string[] | Date[]) {
    date = Utils.toInputDateString(new Date(date));
    if (previousDates.length === 0) {
      return true;
    }
    previousDates = previousDates.map(it => Utils.toInputDateString(new Date(it)));

    return previousDates.find(it => it === date) ? false : true;
  }

  public static isValidJson(jsonString: string): boolean {
    try {
      JSON.parse(jsonString);
      return true;
    } catch {
      return false;
    }
  }

  public static toInputDate(date?: string, withTime = false): string {
    if (!date) return "";

    const d = new Date(date);
    const adjusted = new Date(d.getTime() - d.getTimezoneOffset() * 60000)
      .toISOString();

    return withTime ? adjusted.slice(0, 16) : adjusted.slice(0, 10);
  }

  public static documentMask(v: string) {
    const normalized = (v || "").toUpperCase().replace(/[^A-Z0-9]/g, "")
    const hasLetters = /[A-Z]/.test(normalized)

    if (!hasLetters && normalized.length <= 11) {
      let cpf = normalized.slice(0, 11)
      cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2")
      cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2")
      cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
      return cpf
    }

    return CNPJ.mask(normalized)
  }
  public static hideCpf(cpf: string) {
    if (cpf.length !== 11) {
      return cpf;
    }
    const firstThree = cpf.slice(0, 3);
    const lastTwo = cpf.slice(-2);
    const middle = '.***.***-';

    return `${firstThree}${middle}${lastTwo}`;

  }

  public static hideCnpj(cnpj: string) {
    const cleaned = CNPJ.clear(cnpj);
    if (cleaned.length !== 14) {
      return cnpj;
    }
    const firstTwo = cleaned.slice(0, 2);
    const lastTwo = cleaned.slice(-2);
    const middle = '.***.***/****-';

    return `${firstTwo}${middle}${lastTwo}`;
  }

  public static wait(ms: number) {
    return new Promise(func => setTimeout(func, ms));
  }

  public static capitalizeFirstLetter(word: string) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }

  public static isSameStringArray(arr1: string[], arr2: string[]) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    arr1.sort();
    arr2.sort();

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }

    return true;
  }

  public static fileToBase64 = (file: File) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = function (event) {
        resolve(event.target?.result);
      };

      reader.readAsDataURL(file);
    });
  };


  public static setStartOfDayPlus3Hours(date: Date | string): Date {
    const dateStr = typeof date === 'string' ? date : date.toISOString().split('T')[0];
    return new Date(dateStr + 'T03:00:00.000Z');
  }

  public static setNextDayAt259(date: Date | string): Date {
    const baseDate = new Date(typeof date === 'string' ? date + 'T00:00:00.000Z' : date);
    const nextDay = new Date(baseDate);
    nextDay.setUTCDate(nextDay.getUTCDate() + 1);
    return new Date(nextDay.toISOString().split('T')[0] + 'T02:59:59.999Z');
  }

  public static maskPhone(phone?: string | null): string {
    if (!phone) return "";
    const digits = phone.replace(/\D/g, "");
    const m = digits.match(/^(\d{2})(\d{4,5})(\d)(\d{4})$/);
    if (!m) return phone;
    const ddd = m[1];
    const visibleMid = m[3];
    const last4 = m[4];
    return `(${ddd}) ****${visibleMid}-${last4}`;
  }

  public static maskEmail(email?: string | null): string {
    if (!email) return "";
    const [user, domain] = email.split("@");
    if (!user || !domain) return email;
    if (user.length <= 4) return `${user[0]}***@${domain}`;
    return `${user.slice(0, 2)}****${user.slice(-2)}@${domain}`;
  }

  public static cleanObject = (obj: any) => {
    const objectClean: any = {};

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (value !== null && value !== '' && value !== undefined) {
          objectClean[key] = value;
        }
      }
    }

    return objectClean;
  }

  public static parseAIJsonResponse<T = any>(aiResponse: any): T {
    let jsonString = typeof aiResponse === "string" ? aiResponse.trim() : JSON.stringify(aiResponse)

    const jsonBlockMatch = jsonString.match(/```(?:json)?\s*([\s\S]*?)\s*```/)
    if (jsonBlockMatch) {
      jsonString = jsonBlockMatch[1].trim()
    }

    return JSON.parse(jsonString) as T
  }

  public static moneyMask(value: string | number): string {
    if (typeof value === "number") {
      return value.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      })
    }

    const stringValue = value.toString()
    const numericValue = stringValue.replace(/\D/g, "")

    if (!numericValue || numericValue === "0") return "R$ 0,00"

    const numberValue = Number.parseInt(numericValue) / 100

    return numberValue.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    })
  }

  public static removeMoney(maskedValue: string): number {
    const numericValue = maskedValue.replace(/\D/g, "")

    if (!numericValue || numericValue === "0") return 0

    const numberValue = Number.parseInt(numericValue) / 100

    return numberValue
  }

  public static clamp(value: any, min: number, max: number, opts?: { integer?: boolean; fallback?: number }) {
    let n = Number(value);
    if (Number.isNaN(n)) n = opts?.fallback ?? min;
    if (opts?.integer) n = Math.trunc(n);
    if (n < min) n = min;
    if (n > max) n = max;
    return n;
  }

  public static clampPercent(value: any) {
    if (value === "" || value === null || value === undefined) {
      return null;
    }

    return Utils.clamp(value, 0, 100, { fallback: 0 });
  }

  public static clampDayOfMonth(value: any) {
    if (value === "" || value === null || value === undefined) {
      return "";
    }
    const str = String(value);

    if (!/^\d+$/.test(str)) {
      return "";
    }
    const num = Number(str);

    if (num > 31) {
      return "31";
    }
    return str;
  }


  public static blockInvalidNumberKeys(e: React.KeyboardEvent<HTMLInputElement>) {
    if (["e", "E", "+", "-"].includes(e.key)) e.preventDefault();
  }
}




